import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@src/components/ui/dropdown-menu";
import { type LanTypes } from "@src/helpers";

export const useBasePath = () => {
  const location = useLocation();
  const params = useParams<Record<string, string>>();

  return Object.values(params).reduce(
    (path, param) => path?.replace(`/${param}`, ""),
    location.pathname,
  );
};

function ChangeLanguage() {
  const {
    i18n: { changeLanguage, language },
  } = useTranslation();

  const { hash } = useLocation();
  const basePath = useBasePath();
  const navigate = useNavigate();

  const handleChangeLanguage = (newLanguage: LanTypes) => {
    changeLanguage(newLanguage)
      .then(() => {
        if (hash) {
          navigate(`/${newLanguage}${basePath}${hash}`);
          return;
        }
        navigate(`/${newLanguage}${basePath}`);
      })
      .catch(() => {
        // Handle the error or add meaningful code here.
      });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="outline-none" type="button">
          <p className="text-white">{language.toUpperCase()}</p>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="mt-3 min-w-[6rem] max-sm:mr-2">
        <DropdownMenuCheckboxItem
          checked={language === "ka"}
          onCheckedChange={() => {
            handleChangeLanguage("ka");
          }}
        >
          KA
        </DropdownMenuCheckboxItem>
        <DropdownMenuSeparator />
        <DropdownMenuCheckboxItem
          checked={language === "en"}
          onCheckedChange={() => {
            handleChangeLanguage("en");
          }}
        >
          EN
        </DropdownMenuCheckboxItem>
        {/* <DropdownMenuSeparator /> */}
        {/* <DropdownMenuCheckboxItem
          checked={language === "uk"}
          onCheckedChange={() => {
            handleChangeLanguage("uk");
          }}
        >
          UK
        </DropdownMenuCheckboxItem> */}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ChangeLanguage;
